import { ApiRouteKey } from "../../../common/constants/keys";
import { publicApi } from "../../../core/connections";

export function getLoginValidationQuery(code: string) {
  return new Promise((resolve, reject) => {
    publicApi
      .post(ApiRouteKey.SignIn, null, {
        params: new URLSearchParams({ code }),
      })
      .then((res) => resolve(res.data))
      .catch(reject);
  });
}
